import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { MaintenanceService } from '../services/maintenance/maintenance.service';

@Injectable({ providedIn: 'root' })
export class MaintenancePageGuard implements CanActivate {
  constructor(
    private router: Router,
    private localizeRouterService: LocalizeRouterService,
    private maintenanceService: MaintenanceService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!this.maintenanceService.isMaintenanceActive()) {
      const localizedHome = this.localizeRouterService?.translateRoute('/') as string | undefined;
      const url = localizedHome && typeof localizedHome === 'string' ? localizedHome : '/';
      return this.router.parseUrl(url);
    }
    return true;
  }
}
